export const AUTH_ERRORS = {
  INVALID_CREDENTIALS: "Invalid email or password",
  EMAIL_EXISTS: "Email already registered",
  WEAK_PASSWORD: "Password does not meet security requirements",
  SESSION_EXPIRED: "Session has expired",
  RATE_LIMIT: "Too many attempts. Please try again later",
  UNAUTHORIZED: "Unauthorized",
  REGISTRATION_FAILED: "Registration failed. Please try again.",
  FORGOT_PASSWORD_FAILED: "Failed to send reset link. Please try again.",
  RESET_PASSWORD_FAILED: "Failed to reset password. Please try again.",
  INVALID_EMAIL: "Invalid email address",
  EMAIL_NOT_FOUND: "Email not found",
} as const;
